import Vue from 'vue';
import merge from 'latest_modules/lodash/merge';
import findIndex from 'latest_modules/lodash/findIndex';
import find from 'latest_modules/lodash/find';
import userCommentsApi from '../api/userComments';

import { I18n } from '../util/mixin/i18n.mixin';

export const UserCommentsStoreMutations = {
  LOAD: 'LOAD',
  UPDATED: 'UPDATED',
  FAILED: 'FAILED'
};

class UserCommentsStore {
  static initClass() {
    this.state = {
      thread: null,
      comments: [],
      hasNext: false,
      commentCount: null,
      user: {},
      loadingStatus: null,
      success: null,
      errors: null
    };

    this.prototype.__ = I18n.methods.__;
  }

  getState() {
    return UserCommentsStore.state;
  }

  getThreadInfo() {
    return UserCommentsStore.state.thread;
  }

  getUserInfo() {
    return UserCommentsStore.state.user;
  }

  isUserLogin() {
    return !!(UserCommentsStore.state.user != null
      ? UserCommentsStore.state.user._id
      : undefined);
  }

  canPost() {
    if (!this.getThreadInfo()) {
      return false;
    }
    if (!this.isUserLogin()) {
      return false;
    }
    if (this.getUserInfo().flags.staff) {
      return true;
    }
    if (
      this.getThreadInfo().type === 'projects_backer_only' &&
      !this.getUserInfo().flags.backer
    ) {
      return false;
    }
    return true;
  }

  dispatch(mutation, payload) {
    switch (mutation) {
      case UserCommentsStoreMutations.LOAD:
        UserCommentsStore.state.loadingStatus = 'LOAD';
        UserCommentsStore.state.success = null;
        return (UserCommentsStore.state.errors = null);
      case UserCommentsStoreMutations.UPDATED:
        UserCommentsStore.state.loadingStatus = 'UPDATED';
        return (UserCommentsStore.state.success = payload);
      case UserCommentsStoreMutations.FAILED:
        UserCommentsStore.state.loadingStatus = 'FAILED';
        if (!payload) {
          payload = {
            general: this.__(
              'Oops! An error has occurred. Please try again later.'
            )
          };
        }
        return (UserCommentsStore.state.errors = payload);
    }
  }

  setThreads(err, res) {
    if (err) {
      return this.dispatch(UserCommentsStoreMutations.FAILED);
    }
    if (res) {
      UserCommentsStore.state.thread = res.thread;
      const comments = res.comments.map((c) => merge({ replies: [] }, c));
      UserCommentsStore.state.comments.push(...Array.from(comments || []));
      UserCommentsStore.state.hasNext = res.hasNext;
      UserCommentsStore.state.commentCount = res.commentCount;
      UserCommentsStore.state.user = res.user || {};
    }
    return this.dispatch(UserCommentsStoreMutations.UPDATED);
  }

  /*
  コメントスレッドを取得する
  @param {String} url
  @param {Object} options
  */
  getThreads(url, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    return userCommentsApi.getThreads(url, options, (err, res) => {
      return this.setThreads(err, res);
    });
  }

  /*
  コメント投稿をPOSTする
  @param {String} threadId
  @param {String} comment
  @param {Object} options
  */
  postComment(threadId, comment, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    return userCommentsApi.postComment(
      threadId,
      comment,
      options,
      (err, res) => {
        if (err) {
          return this.dispatch(UserCommentsStoreMutations.FAILED, {
            general: this.__(
              'Your comment was not posted. Please try again later.'
            )
          });
        }
        if (res) {
          UserCommentsStore.state.comments.unshift(merge({ replies: [] }, res));
          UserCommentsStore.state.commentCount++;
        }
        return this.dispatch(UserCommentsStoreMutations.UPDATED);
      }
    );
  }

  /*
  編集したコメントをPOSTする
  @param {String} commentId
  @param {String} comment
  @param {Object} options
  */
  postEditComment(commentId, comment, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    const threadId = UserCommentsStore.state.thread._id;
    return userCommentsApi.postEditComment(
      threadId,
      commentId,
      comment,
      options,
      (err, res) => {
        if (err) {
          return this.dispatch(UserCommentsStoreMutations.FAILED, {
            general: this.__(
              'Your comment was not posted. Please try again later.'
            )
          });
        }
        var update = function (comments) {
          const index = findIndex(comments || [], (c) => c._id === res._id);
          if (index > -1) {
            Vue.set(comments, index, merge({}, comments[index], res));
            return true;
          }
          for (comment of Array.from(comments || [])) {
            const updated = update(comment.replies);
            if (updated) {
              return true;
            }
          }
        };
        update(UserCommentsStore.state.comments);
        return this.dispatch(UserCommentsStoreMutations.UPDATED);
      }
    );
  }

  /*
  コメント投稿をDELETEする
  @param {String} commentId
  @param {Object} options
  */
  deleteComment(commentId, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    return userCommentsApi.deleteComment(commentId, options, (err, res) => {
      if (err) {
        return this.dispatch(UserCommentsStoreMutations.FAILED);
      }
      var remove = function (comments) {
        const index = findIndex(comments || [], (c) => c._id === res._id);
        if (index >= 0) {
          Vue.delete(comments, index);
          return 1;
        }
        for (let comment of Array.from(comments || [])) {
          const removed = remove(comment.replies);
          if (removed) {
            return 0;
          }
        }
        return 0;
      };
      UserCommentsStore.state.commentCount -= remove(
        UserCommentsStore.state.comments
      );
      return this.dispatch(UserCommentsStoreMutations.UPDATED);
    });
  }

  /*
  返信コメントをPOSTする
  @param {String} commentId
  @param {String} comment
  @param {Object} options
  */
  postReply(commentId, comment, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    return userCommentsApi.postReply(
      commentId,
      comment,
      options,
      (err, res) => {
        if (err) {
          return this.dispatch(UserCommentsStoreMutations.FAILED, {
            general: this.__(
              'Your comment was not posted. Please try again later.'
            )
          });
        }
        if (res) {
          comment = find(
            UserCommentsStore.state.comments,
            (c) => c._id === commentId
          );
          comment.replies.push(res);
        }
        return this.dispatch(UserCommentsStoreMutations.UPDATED);
      }
    );
  }

  /*
  レポート報告をPOSTする
  @param {String} commentId
  @param {String} text
  @param {Object} options
  */
  postReport(commentId, text, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    return userCommentsApi.postReport(commentId, text, options, (err) => {
      if (err) {
        return this.dispatch(UserCommentsStoreMutations.FAILED);
      }
      return this.dispatch(UserCommentsStoreMutations.UPDATED, {
        message: this.__(
          'Thank you for submitting a report. The comment in question will be deleted if deemed inappropriate.'
        )
      });
    });
  }

  /*
  スパム報告をPOSTする
  @param {String} commentId
  @param {Object} options
  */
  postMarkAsSpam(commentId, options) {
    this.dispatch(UserCommentsStoreMutations.LOAD);
    return userCommentsApi.postMarkAsSpam(commentId, options, (err) => {
      if (err) {
        return this.dispatch(UserCommentsStoreMutations.FAILED);
      }
      return this.dispatch(UserCommentsStoreMutations.UPDATED);
    });
  }
}
UserCommentsStore.initClass();

export const userCommentsStore = new UserCommentsStore();
